import { bl_cms_calendar_event_hdr_RowClass } from '../../../dbschema/bl_cms_calendar_event_hdr.model';
import {BaseContainerModel} from '../../base-container.model';

export class CmsEventContainerModel extends BaseContainerModel{
    bl_cms_calendar_event_hdr: bl_cms_calendar_event_hdr_RowClass = new bl_cms_calendar_event_hdr_RowClass();
}